import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { multilingualServiceDS } from './multilingualService'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(multilingualServiceDS)
}
